import {
    GET_HOMEPAGE_FEED_START,
    GET_HOMEPAGE_FEED_SUCCESS,
    GET_HOMEPAGE_FEED_FAIL
} from './constants';
import { fetchFeedsApi } from '../../api';
import mockHelper from '../../../common/mockHelper';

export function fetchFeeds(params) {
    return (dispatch) => {
        dispatch({
            type: GET_HOMEPAGE_FEED_START,
        });
        let promise;
        if (process.env.REACT_APP_MOCK == 'MOCK2') {
            promise = mockHelper('home_page')
        } else {
            promise = fetchFeedsApi(params)
        }

        return promise.then((response) => {
            const data = response.data.list;
            const isEnd = response.data.is_page_end;
            if (response.isError) {
                dispatch({
                    type: GET_HOMEPAGE_FEED_FAIL,
                })
                throw new Error('error')
            }
            dispatch({
                type: GET_HOMEPAGE_FEED_SUCCESS,
                data: {
                    data,
                    isEnd
                }
            })
            return data
        })
    }
}

export function reducer(state, action) {
    switch(action.type) {
        case GET_HOMEPAGE_FEED_START:
            return {
                ...state,
                isFetchingFeed: true,
                fetchingFeedError: false,
            };
        case GET_HOMEPAGE_FEED_SUCCESS:
            return {
                ...state,
                feedsList: [...state.feedsList, ...action.data.data],
                isFetchingFeed: false,
                isFeedsEnd: action.data.isEnd,
            };
        case GET_HOMEPAGE_FEED_FAIL:
            return {
                ...state,
                isFetchingFeed: false,
                fetchingFeedError: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/homepage/redux/fetchFeeds.js